<div class="property-info">
    <div class="price-info paragraph">
        @if (selectedSale().judicialTransferDate || selectedSale().actualSaleDate) {
        <div class="entry">
            @if(selectedSale().actualSaleDate) {
            <span>Solgt {{ selectedSale().actualSaleDate | date : "dd.MM.yyyy" | dash }}</span>
            } @else{
            <span>Tinglyst {{ selectedSale().judicialTransferDate | date : "dd.MM.yyyy" | dash }}</span>
            }
            <span>{{ selectedSale().salesPrice | number : "1.0-0" | dash }}</span>
        </div>
        } @if(selectedSale().askingPrice) {
        <div class="entry">
            <span>Til salgs fra {{ selectedSale().informationDate | date : "dd.MM.yyyy" | dash }}</span>
            <span>{{ selectedSale().askingPrice | number : "1.0-0" | dash }}</span>
        </div>
        } @if(selectedSale().surveyorAppraisalDate) {
        <div class="entry">
            <span>Takst pr {{ selectedSale().surveyorAppraisalDate | date : "dd.MM.yyyy" | dash }}</span>
            <span>{{ selectedSale().askingPrice | number : "1.0-0" | dash }}</span>
        </div>
        }
    </div>

    <div class="estate-agent paragraph">{{ selectedSale().estateAgent | dash }}</div>

    <div class="key-info paragraph">
        <div class="entry">
            <span>Byggeår</span>
            <span>{{ selectedSale().buildYear | dash }}</span>
        </div>
        <div class="entry">
            <span>Renovert år</span>
            <span>{{ selectedSale().renovatedYear | dash }}</span>
        </div>
        <div class="entry">
            <span>Totalt BTA</span>
            <span>{{ selectedSale().totalGrossArea | dash | areaconverter }}</span>
        </div>
        <div class="entry">
            <span>Totalt BRA</span>
            <span>{{ selectedSale().totalUsableArea | dash | areaconverter }}</span>
        </div>
        <div class="entry">
            <span>Antall etasjer</span>
            <span>{{ selectedSale().numberOfFloors | dash }}</span>
        </div>
        <div class="entry">
            <span>Parkering</span>
            <span>{{ selectedSale().parkingTypeName | dash }}</span>
        </div>
        <div class="entry">
            <span>Heis</span>
            <span>{{ selectedSale().hasElevator ? "Ja" : ("Nei" | dash) }}</span>
        </div>
    </div>

    <div class="rental-info paragraph">
        <div class="entry">
            <span>Leieinntekt per år</span>
            <span>{{ selectedSale().rentalIncomePerYear | number : "1.0-0" | dash }}</span>
        </div>
        <div class="entry">
            <span>Utleiestatus</span>
            <span>{{ selectedSale().rentalStatusDescription | dash }}</span>
        </div>
        <div class="entry">
            <span>Uteleiandel</span>
            <span>{{ selectedSale().rentalShare * 100 | dash }}%</span>
        </div>
    </div>

    <div class="fee-info paragraph">
        <div class="entry">
            <span>Formuesverdi</span>
            <span>{{ selectedSale().propertyValue | number : "1.0-0" | dash }}</span>
        </div>
        <div class="entry">
            <span>Kommunale avgifter</span>
            <span>{{ selectedSale().municipalTaxes | number : "1.0-0" | dash }}</span>
        </div>
        <div class="entry">
            <span>Festeavgift</span>
            <span>{{ selectedSale().plotLease | number : "1.0-0" | dash }}</span>
        </div>
        <div class="entry">
            <span>Utløp festekontrakt</span>
            <span>{{ selectedSale().plotLeaseContractExpireDate | date : "dd.MM.yyyy" | dash }}</span>
        </div>
    </div>

    <div class="links">
        <a target="_blank" [routerLink]="['/resolve/infopage']" [queryParams]="{ unitID: selectedSale().unitId }" class="open-in-evinfo">
            <span>Åpne i evInfo</span>
            <div class="external-link-icon"></div>
        </a>
        @if (selectedSale().sourceUrl) {
        <a [href]="selectedSale().sourceUrl" target="_blank" class="see-finn">
            <div class="finn-icon"></div>
            <span>Se Finn-annonse</span>
            <div class="external-link-icon"></div>
        </a>
        }
    </div>
</div>
